import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    title: 'The 8-Minute Daily Matrix',
    desc: "The exact 4-step sequence to 'unstick' your hips and neck during your lunch break."
  }, {
    title: "The 'Nerve-Glide' Protocol",
    desc: "A specific movement to floss the sciatic nerve through tight tissue and stop the 'lightning' pain instantly."
  }, {
    title: 'The Tech-Neck Tech-Fix',
    desc: 'How to reset your cervical spine and end 3 PM tension headaches.'
  }, {
    title: 'The Desk Decompression',
    desc: 'A simple move using your office desk to pull your vertebrae apart and let your discs breathe.'
  }, {
    title: "The 10-Second 'Glute-Wakeup' Habit",
    desc: 'A neurological hack to protect your back every time you stand up.'
  }];
  return <section className="w-full bg-dark-panel py-24 border-b border-dark-lighter" data-id="element-215">
      <div className="max-w-4xl mx-auto px-6" data-id="element-216">
        <FadeIn data-id="element-217">
          <h2 className="font-display text-4xl md:text-5xl font-bold uppercase mb-12 text-center" data-id="element-218">
            Inside The <span className="text-cyan-accent" data-id="element-219">Matrix</span>
          </h2>

          <div className="space-y-4" data-id="element-220">
            {items.map((item, index) => <div key={index} className="bg-dark p-6 md:p-8 border border-dark-lighter flex items-start gap-6 hover:border-cyan-accent/50 transition-colors" data-id="element-221">
                <div className="mt-1" data-id="element-222">
                  <CheckCircle2 className="w-8 h-8 text-cyan-accent" data-id="element-223" />
                </div>
                <div data-id="element-224">
                  <h3 className="font-display text-2xl uppercase mb-2 text-white" data-id="element-225">
                    {item.title}
                  </h3>
                  <p className="text-gray-400 text-lg" data-id="element-226">{item.desc}</p>
                </div>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}